import React from "react";
import Styles from "./relatif.module.scss";
import { Markup } from "interweave";
import RelatifService from "services/relatifService";
import { Container } from "reactstrap";

interface IRelatifProps { }

interface IRelatifState {
  relatif: string;
}

class Relatif extends React.Component<IRelatifProps, IRelatifState> {
  /**
   *
   */
  constructor(props: IRelatifProps) {
    super(props);

    this.state = { relatif: '' };
  }

  componentDidMount() {
    RelatifService.GetRelatif().then((relatif) => {
      this.setState({
        relatif: relatif
      });
    })
  }

  render() {
    if (this.state.relatif) {
      return (
        <div className={Styles.Relatif}>
          <Container>
            <Markup content={this.state.relatif} />
          </Container>
        </div>
      );
    }
    else {
      return null;
    }

  }
}

export default Relatif;
